import PropTypes from 'prop-types';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import AddFundErrorMessage from './add-funds-error-message';
import style from './style.module.less';

const AddFundsErrorSection = ({ errors, minimumFundingAmount }) => {
  return (
    <div className={style['error-banner']}>
      <BannerMessageV2
        className={style['error-message']}
        content={
          <ul>
            {errors?.map((error, index) => {
              return <AddFundErrorMessage key={index} error={error} minimumFundingAmount={minimumFundingAmount} />;
            })}
          </ul>
        }
        status={BannerStatus.Error}
      />
    </div>
  );
};

AddFundsErrorSection.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  minimumFundingAmount: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

export default AddFundsErrorSection;
